/**
 * 帳務列右側大數字與單位的 utility 組合。帳單頁、語音用量列、儲值金列共用，
 * 值走 token（--fs-stat-md），不在各頁各寫一份。
 */
export const billingStatClassName =
  'font-mono text-[length:var(--fs-stat-md)] font-semibold leading-none tabular-nums'

export const billingUnitClassName = 'font-sans text-sm font-normal text-muted'
